import { Component, computed, effect, inject, signal } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { DashedRingComponent } from '@components/dashed-ring/dashed-ring.component';
import { ImageGeneratorComponent } from '@components/image-generator/image-generator.component';
import { variables } from '@shared/helper/configs';
import { bottomNavigationProfileSP } from '@shared/helper/responsive-sizes';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';

@Component({
  selector: 'app-bottom-navigation',
  imports: [
    MatIconModule,
    MatRippleModule,
    ImageGeneratorComponent,
    RouterLink,
    RouterLinkActive,
    DashedRingComponent,
  ],
  templateUrl: './bottom-navigation.component.html',
  styleUrl: './bottom-navigation.component.scss',
})
export class BottomNavigationComponent {
  profileSizes = bottomNavigationProfileSP;
  showRemainingTooltip = signal(false);
  remainingDays = computed<number | undefined>(() => {
    return this.tokenService.userSubscriptionDetails()?.remainingDays;
  });
  userInfo = computed(() => {
    return this.tokenService.userInfo();
  });

  private generalService = inject(GeneralService);
  private tokenService = inject(TokenService);

  constructor() {
    effect(() => {
      this.showRemainingTooltip.set(
        this.remainingDays()! <= 7 && this.generalService.checkShowSubscriptionAlertTooltip(),
      );
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.closeTooltip();
    }, 4000);
  }

  closeTooltip() {
    this.showRemainingTooltip.set(false);
    if (this.generalService.isBrowserOnly) {
      sessionStorage.setItem(variables.subscriptionAlertTooltip, new Date().toISOString());
    }
  }

  get handleDashedColor(): string[] {
    return this.generalService.handleDashedColor(this.remainingDays()!);
  }
}
